<template>
    <div class="page" :class="$route.params.type">
        <div class="main-icon" v-show="onPage"></div>
        <router-view />
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    computed: {
        ...mapState('sections', ['sections']),
        onPage() {
            return this.$route.name == 'applicationDetail';
        }
    },
    mounted() {},
    methods: {
        ...mapActions(['setCurrentInfoPanel'])
    }
};
</script>

<style lang="scss"></style>
